/**
 * Minimal TopoJSON → GeoJSON decoder.
 * Handles the world-atlas format without needing the full topojson-client library.
 */
export default function topoFeature(topo, obj) {
  const t = topo.transform;
  const s = t.scale;
  const tr = t.translate;

  const arcs = topo.arcs.map((arc) => {
    let x = 0, y = 0;
    return arc.map((p) => {
      x += p[0];
      y += p[1];
      return [x * s[0] + tr[0], y * s[1] + tr[1]];
    });
  });

  const arc = (i) => (i >= 0 ? arcs[i] : arcs[~i].slice().reverse());

  const ring = (r) => {
    const coords = [];
    r.forEach((i) => {
      const a = arc(i);
      coords.push(...(coords.length ? a.slice(1) : a));
    });
    return coords;
  };

  const geom = (g) => {
    if (g.type === "Polygon")
      return { type: "Polygon", coordinates: g.arcs.map(ring) };
    if (g.type === "MultiPolygon")
      return { type: "MultiPolygon", coordinates: g.arcs.map((p) => p.map(ring)) };
    return g;
  };

  return {
    type: "FeatureCollection",
    features: obj.geometries.map((g) => ({
      type: "Feature",
      id: g.id,
      properties: g.properties || {},
      geometry: geom(g),
    })),
  };
}
